export default "__VITE_ASSET__BFb55qIe__"